import { useCallback, useEffect } from 'react';
import { Divider } from '@signavio/ui';
import { useActivateValue, useActiveIndex, useDataSourceDescriptors, useRegisterDataSource, useSelectValue } from './AutocompleteContext';
import DataItem from './DataItem';
import { useDataSourceLocation } from './DataSourceContext';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DataSource({
  type,
  data,
  children,
  disableItem,
  emptyHint,
  onSelect
}) {
  const isRegistered = useRegisterDataSource(type, data.length);
  const canBeActivated = useCallback(index => {
    if (!disableItem) {
      return true;
    }
    const item = data[index];

    // it can happen that an index is checked
    // even though the data has already been
    // updated and the item does not exist.
    if (!item) {
      return false;
    }
    return !disableItem(item);
  }, [data, disableItem]);
  const [activeIndex, selectIndex] = useActiveIndex(type, canBeActivated);
  const [activateValue, deactivateValue] = useActivateValue();
  const dataSourceDescriptors = useDataSourceDescriptors();
  const {
    index
  } = useDataSourceLocation();
  const handleSelect = useCallback((selectedType, selectedItem) => {
    if (selectedType === type && onSelect) {
      onSelect(selectedItem);
    }
  }, [onSelect, type]);
  const selectValue = useSelectValue(handleSelect);
  useEffect(() => {
    if (activeIndex !== -1) {
      if (!canBeActivated(activeIndex)) {
        deactivateValue();
      } else {
        const item = data[activeIndex];
        if (item) {
          activateValue(type, item);
        }
      }
    }
  }, [activateValue, activeIndex, canBeActivated, data, deactivateValue, type]);
  if (data.length === 0) {
    return emptyHint ? /*#__PURE__*/_jsx(_Fragment, {
      children: emptyHint
    }) : null;
  }
  if (!isRegistered) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [index > 0 && !firstWithResults(dataSourceDescriptors, index) && /*#__PURE__*/_jsx(Divider, {}), data.map((item, index) => /*#__PURE__*/_jsx(DataItem, {
      active: index === activeIndex,
      disabled: disableItem ? disableItem(item) : false,
      onMouseEnter: () => selectIndex(index),
      onClick: event => selectValue(type, item, event),
      children: children(item)
    }, item.id))]
  });
}
const firstWithResults = (dataSourceDescriptors, tillIndex) => dataSourceDescriptors.reduce((result, dataSourceDescriptor, index) => {
  if (index < tillIndex) {
    return dataSourceDescriptor.numberOfItems === 0;
  }
  return result;
}, false);
export default DataSource;